import getUrlFromLink from "./getUrlFromLink";

export default getUrlFromLink;
